import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  ViewContainerRef,
  createComponent,
  inject,
  contentChild,
} from '@angular/core';
import { ButtonLoadingContentDirective } from './button-loading-content.directive';
import { ButtonLoadingComponent } from '../../components/button-loading/button-loading.component';

@Directive({
  selector: '[mytcButtonLoading]',
  standalone: true,
})
export class ButtonLoadingDirective implements OnChanges, AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly appRef = inject(ApplicationRef);
  private readonly cd = inject(ChangeDetectorRef);

  readonly buttonLoadingContent = contentChild(ButtonLoadingContentDirective);
  readonly buttonLoadingComponentView = contentChild(ButtonLoadingContentDirective, { read: ViewContainerRef });

  @Input({ required: true }) isLoading: boolean;
  @Input() autoDisableWhileLoading = true;
  @Input() spinnerColor = 'var(--mytc-white)';
  @Input() diameterSize = 20;

  @HostBinding('style.position') protected readonly hostPosition = 'relative';

  private buttonLoadingComponent: ComponentRef<ButtonLoadingComponent>;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.isLoading.firstChange) {
      this.handleLoadingDisplay();
    }
  }

  ngAfterViewInit(): void {
    this.handleLoadingDisplay();

    this.cd.detectChanges();
  }

  private handleLoadingDisplay(): void {
    const buttonLoadingContent = this.buttonLoadingContent();
    if (buttonLoadingContent && this.buttonLoadingComponentView()) {
      if (this.isLoading) {
        buttonLoadingContent.hide();
        this.attachLoadingComponent();
      } else {
        buttonLoadingContent.show();
        this.detachLoadingComponent();
      }
    } else {
      console.error('Missing ButtonLoadingContentDirective instance!');
    }
  }

  attachLoadingComponent(): void {
    const buttonLoadingComponent = createComponent(ButtonLoadingComponent, {
      environmentInjector: this.appRef.injector,
    });

    buttonLoadingComponent.setInput('diameter', this.diameterSize);
    buttonLoadingComponent.setInput('withAbsoluteWrapper', true);
    buttonLoadingComponent.setInput('spinnerColor', this.spinnerColor);

    if (this.autoDisableWhileLoading) {
      this.el.nativeElement.disabled = true;
    }

    this.buttonLoadingComponentView().insert(buttonLoadingComponent.hostView);

    this.buttonLoadingComponent = buttonLoadingComponent;

    buttonLoadingComponent.changeDetectorRef.detectChanges();
  }

  private detachLoadingComponent(): void {
    this.buttonLoadingComponent?.destroy();

    if (this.autoDisableWhileLoading) {
      this.el.nativeElement.disabled = false;
    }
  }
}
